import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { ChristmasSectionHeading } from './ChristmasSectionHeading';
import { christmasFaqs } from '../../../data/christmasPage';
export function ChristmasFaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="christmas-faq" aria-labelledby="christmas-faq-title" className="scroll-mt-32 bg-cream py-20 md:py-28" data-id="element-166" data-mp="3c5co7ghjes6s">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-167" data-mp="2kg9irxdwzbsk">
        <ChristmasSectionHeading eyebrow="FAQ" title="Frequently asked questions." titleId="christmas-faq-title" data-id="element-168" data-mp="2kh16km19s58a" />
        <ul className="mt-12 space-y-3" data-id="element-169" data-mp="2og077ufyxftx">
          {christmasFaqs.map((faq, i) => {
          const open = openIndex === i;
          return <li key={faq.q} className="overflow-hidden rounded-2xl bg-white ring-1 ring-forest/[0.07]" data-id="element-170" data-mp="1wrq85b7e6mxb" data-mpi={i}>
                <h3 data-id="element-171" data-mp="20rgzbg0tz52d">
                  <button type="button" onClick={() => setOpenIndex(open ? null : i)} aria-expanded={open} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-semibold text-forest transition-colors hover:text-olive focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-sage" data-id="element-172" data-mp="20qz0qcqp4era">
                    {faq.q}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-olive transition-transform duration-200 ${open ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-173" data-mp="19ghellpjiw5e" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-174" data-mp="vklzzs26c77t">
                  {open && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2
              }} className="overflow-hidden" data-id="element-175" data-mp="2uv3yo4eacx0t">
                      <p className="px-6 pb-5 text-[15px] leading-relaxed text-forest/70" data-id="element-176" data-mp="ea8nbwdcuc3r">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}